import React from 'react'
import { PropsWithChildren, useState } from 'react'
import { SpinnerContext, SpinnerOptions } from './SpinnerContext'
import { Spinner } from './Spinner'

/**
 * SpinnerActionProvider 元件
 */
const SpinnerActionProvider = ({ children }: PropsWithChildren) => {
  const [spinners, setSpinners] = useState<SpinnerOptions[]>([])

  const showSpinner = ({ uid, message }: SpinnerOptions) => {
    setSpinners((_spinners) => {
      if (_spinners.some((spinner) => spinner.uid === uid)) {
        return _spinners.map((spinner) =>
          spinner.uid === uid ? { ...spinner, message } : spinner,
        )
      }

      return _spinners.concat({ uid, message })
    })

    return uid
  }

  const hideSpinner = (uid: string) => {
    setSpinners((_spinners) => {
      return _spinners.filter((spinner) => spinner.uid !== uid)
    })

    return uid
  }

  const clearSpinner = () => {
    setSpinners([])
  }

  return (
    <SpinnerContext.Provider
      value={{
        spinners,
        showSpinner,
        hideSpinner,
        clearSpinner,
      }}
    >
      {children}
    </SpinnerContext.Provider>
  )
}

export function SpinnerProvider({ children }: PropsWithChildren) {
  return (
    <SpinnerActionProvider>
      <>
        {children}
        <Spinner />
      </>
    </SpinnerActionProvider>
  )
}
